var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3021_3333",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3021_3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99216 15.9453C9.82758 15.9453 9.66918 15.9167 9.51696 15.8596C9.36473 15.8024 9.22022 15.7124 9.08342 15.5896L8.09467 14.689C6.5755 13.3418 5.24939 12.0391 4.11633 10.7811C2.98328 9.52303 2.41675 8.19317 2.41675 6.7915C2.41675 5.6922 2.79466 4.7715 3.5505 4.02942C4.30647 3.28748 5.24105 2.9165 6.35425 2.9165C6.99841 2.9165 7.63786 3.06449 8.27258 3.36046C8.90716 3.65643 9.483 4.15963 10.0001 4.87005C10.5449 4.15963 11.1277 3.65643 11.7484 3.36046C12.3692 3.06449 13.0017 2.9165 13.6459 2.9165C14.7591 2.9165 15.6937 3.28748 16.4497 4.02942C17.2055 4.7715 17.5834 5.6922 17.5834 6.7915C17.5834 8.20928 17.0036 9.55116 15.8438 10.8171C14.6841 12.0831 13.3713 13.371 11.9055 14.6809L10.9086 15.5896C10.772 15.7124 10.6262 15.8024 10.4713 15.8596C10.3163 15.9167 10.1566 15.9453 9.99216 15.9453Z",
    fill: "#4B4B4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart-filled.59b30f5b7006b2c947b1c290766a29fb.svg";
export { ForwardRef as ReactComponent };